import envValues from '../enviornment';

export const SERVER_URL = `${envValues.REACT_APP_API_ENDPOINT}/auth`;
export const SERVER_BASE_URL = envValues.REACT_APP_API_ENDPOINT;
export const ERROR_MESSAGE = 'Api Fetch Error!';
export const ENCRYPT_SECERET_KEY = 'armia-secret-key@123';
export const REACT_APP_API_POST_USER = `${envValues.REACT_APP_API_ENDPOINT}/user`;
export const REACT_APP_API_FETCH_USER = `${envValues.REACT_APP_API_ENDPOINT}/user/empolyer?`;
export const REACT_APP_API_FETCH_FREE_TRIAL = `${envValues.REACT_APP_API_ENDPOINT}/trial?`;
export const REACT_APP_API_FETCH_EXPIRING_USERS = `${envValues.REACT_APP_API_ENDPOINT}/trial/expiring-users?`;
export const REACT_APP_API_FETCH_EMPLOYEE = `${envValues.REACT_APP_API_ENDPOINT}/employee?active=true&`;
export const REACT_APP_API_FETCH_ROLE = `${envValues.REACT_APP_API_ENDPOINT}/roles?active=true&`;
export const REACT_APP_API_SKILLS = `${envValues.REACT_APP_API_ENDPOINT}/dummy/selectdata`;
export const REACT_APP_API_ROLES_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/roles/select`;
export const REACT_APP_API_FETCH_MOVIES = `${envValues.REACT_APP_API_ENDPOINT}/movies?active=true&`;
export const REACT_APP_API_FETCH_NOTIFICATIONS = `${envValues.REACT_APP_API_ENDPOINT}/notifications?`;
export const REACT_APP_API_FETCH_PLANS = `${envValues.REACT_APP_API_ENDPOINT}/plans?`;
export const REACT_APP_API_FETCH_INTERVENTIONS = `${envValues.REACT_APP_API_ENDPOINT}/interventions?`;
export const REACT_APP_API_FETCH_CATEGORYS_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/categorys/select`;
export const REACT_APP_API_FETCH_EMPOLYEE = `${envValues.REACT_APP_API_ENDPOINT}/user/empolyee`;
export const REACT_APP_API_FETCH_USER_COUNT = `${envValues.REACT_APP_API_ENDPOINT}/user/userCount`;
export const REACT_APP_API_FETCH_PAGES = `${envValues.REACT_APP_API_ENDPOINT}/pages?`;
export const REACT_APP_API_FETCH_INQUIRYS = `${envValues.REACT_APP_API_ENDPOINT}/inquiry?`;
